var _defs, _path, _polyline, _polyline2, _polyline3, _polyline4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.26,3.2s19.62,19.83,27.66,43.48c8.04,23.64,5.2,52.8-27.66,55.48,0,0-30.34,2.05-32.07-34.52C17.86,39.71,51.26,3.2,51.26,3.2Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "40.46 16.64 51.54 30.46 62.08 42.58 70.35 52.69 82.7 68.05 71.48 75.38 62.74 79.05 51.26 83.84 44.6 88.63"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "65.11 98.83 57.95 88.63 51.26 83.84 40.37 79.23 31.31 75.41 19.18 67.64 32.57 52.69 40.71 42.69 51.54 30.46 57.19 23.41 62.72 16.94"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "57.19 23.41 72.91 32.99 70.35 52.69 67.94 62.88 62.74 79.05 57.95 88.63 51.26 102.15 44.6 88.63 40.37 79.23 35.01 63.07 32.57 52.69 30.17 32.42 45.82 23.6"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "57.95 88.63 76.44 89.84 71.48 75.38 68.19 63.73 62.08 42.58 57.19 23.41 51.26 3.2 45.82 23.6 40.47 43.62 35.01 63.07 26.65 90.93 44.6 88.63 36.95 99.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPear);
export default __webpack_public_path__ + "static/media/pear.b5401f3ce26fea0cdb61eebe639b04b9.svg";
export { ForwardRef as ReactComponent };